import React from 'react';
import Icon from 'components/AppIcon';

const LEGAL_MATTER_CATEGORIES = [
  {
    id: 'family-law',
    name: 'Family Law',
    icon: 'Users',
    description: 'Divorce, custody, adoption, marriage'
  },
  {
    id: 'property-disputes',
    name: 'Property Disputes',
    icon: 'Home',
    description: 'Land, real estate, tenancy issues'
  },
  {
    id: 'employment-issues',
    name: 'Employment Issues',
    icon: 'Briefcase',
    description: 'Wrongful termination, contracts, disputes'
  },
  {
    id: 'criminal-defense',
    name: 'Criminal Defense',
    icon: 'Shield',
    description: 'Criminal charges, bail, representation'
  },
  {
    id: 'business-commercial',
    name: 'Business & Commercial',
    icon: 'Building',
    description: 'Contracts, partnerships, compliance'
  },
  {
    id: 'personal-injury',
    name: 'Personal Injury',
    icon: 'Heart',
    description: 'Accidents, medical negligence, compensation'
  },
  {
    id: 'immigration',
    name: 'Immigration',
    icon: 'Globe',
    description: 'Visas, citizenship, deportation'
  },
  {
    id: 'civil-litigation',
    name: 'Civil Litigation',
    icon: 'FileText',
    description: 'General disputes, claims, lawsuits'
  },
  {
    id: 'other',
    name: 'Other',
    icon: 'MoreHorizontal',
    description: 'Other legal matters'
  }
];

const LegalMatterSelector = ({ value, onChange, error }) => {
  const handleSelect = (categoryId) => {
    onChange(categoryId);
  };

  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-text-primary mb-3">
        Legal Matter Category *
      </label>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {LEGAL_MATTER_CATEGORIES?.map((category) => {
          const isSelected = value === category?.id;
          return (
            <button
              key={category?.id}
              type="button"
              onClick={() => handleSelect(category?.id)}
              className={`p-4 border-2 rounded-lg text-left transition-all hover:shadow-md ${
                isSelected
                  ? 'border-primary bg-primary-50'
                  : error
                  ? 'border-error bg-error-50' :'border-border bg-white hover:border-primary-200'
              }`}
            >
              <div className="flex items-start space-x-3">
                <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${
                  isSelected ? 'bg-primary' : 'bg-gray-100'
                }`}>
                  <Icon 
                    name={category?.icon} 
                    size={20} 
                    className={isSelected ? 'text-white' : 'text-text-secondary'} 
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className={`font-medium mb-1 ${
                    isSelected ? 'text-primary' : 'text-text-primary'
                  }`}>
                    {category?.name}
                  </h3>
                  <p className="text-xs text-text-secondary">{category?.description}</p>
                </div>
                {isSelected && (
                  <Icon name="CheckCircle" size={20} className="text-primary flex-shrink-0" />
                )}
              </div>
            </button>
          );
        })}
      </div>

      {error && (
        <p className="text-error text-xs mt-2">{error}</p>
      )}
    </div>
  );
};

export default LegalMatterSelector;